import { BaseRoute } from './Route'
import { ROUTES } from './Routes'

//
// A menu is a collection of submenus, each with a title.
// 
interface IMenu {
  [key:string]: ISubmenu
}

//
// A submenu is a collection of routes, each with a title.
// 
interface ISubmenu {
  [key: string]: BaseRoute
}

/*
 * The application's main menu consists of groups and items.
 * A group has a key (its name), and an object containing items.
 * Each object has:
 * - A key (the item label)
 * - A reference to a route to load.
 * Menu items are only rendered if route conditions are satisfied.
 */
const MENU: IMenu = {
  "Data": {
    "Dashboard": ROUTES['dashboard'],
    "Projects": ROUTES['projects_list'],
    "Campaigns": ROUTES['campaigns_list'],
    "Stations": ROUTES['stations_list'],
    "Samples": ROUTES['samples_list'],
    "Parameters": ROUTES['parameters_list'],
    "Results": ROUTES['results_list'],
    "Analysis": ROUTES['analysis']
  },
  "Categories": {
    'Station categories': ROUTES['stationcategories_list'],
    'Parameter categories': ROUTES['parametercategories_list'],
  },
  "Users": {
    "Users": ROUTES['users_list'],
    "Profiles": ROUTES['profiles_list'],
    "Log": ROUTES['logs_list']
  }
} 

export { MENU, IMenu, ISubmenu }